export const ColorKey = {
    appointment: '2', //#7ae7bf
    event: '5', //#fbd75b
    blockTime: '4', //#ff887c
    default: '9',
};
